<template>
    <div>
        <date-picker v-model="date" class="mb-2 w-100" format = "MM/DD/YYYY"></date-picker>
        <br>
        <Mentionable
            :keys="['@']"
            :items="usersMentionList"
            offset="6"
            insert-space
            placement="top-start"
            @apply="mentionApplied = true"
        >
            <template #item-@="{ item }">
                <div class="user">
                    <Avatar
                        :username="item.name"
                        :src="item.avatar"
                        :size="25"
                    >
                    </Avatar>

                    <div class="mention-item__inner">
                        {{ item.value }}
                        <span class="dim">
                            ({{ item.name }})
                        </span>
                    </div>
                </div>
            </template>

            <textarea v-model="interaction.comment" class="form-control--mid form-control"></textarea>
        </Mentionable>
    </div>
</template>

<script>
import interactions from "@/services/interactions.service"
import DatePicker from "vue2-datepicker";
import {Mentionable} from "vue-mention";
import Avatar from "vue-avatar";

export default {
    components: {
        DatePicker,
        Mentionable,
        Avatar
    },

    props: {
        type: String,
        usersMentionList: Array,
        companyType: String,
        companyId: Number,
    },

    data() {
        return {
            id: 0,

            interaction: {
                type: this.type,
                comment: "",
                date: "",
            },

            date: "",
        }
    },

    watch: {
        type() {
            this.init(0)
        },

        date() {
            this.interaction.date = this.dateHelper.encodeDateForServer(this.date)
        }
    },

    methods: {
        init(id) {
            this.id = id
            this.interaction.type = this.type
            this.interaction.date = ""
            this.interaction.comment = ""

            if (this.id) {
                interactions.getEdit(this.id).then(response => {
                    this.interaction = response.data

                    if (this.interaction.date) {
                        this.date = this.dateHelper.decodeDateFromServer(this.interaction.date)
                    }
                })
            }
            else {
                this.date = new Date()
            }
        },

        save() {
            interactions.save(this.id, this.companyType, this.companyId, this.interaction).then(() => {
                this.$emit('saved')
            })
        },
    }
}
</script>

<style scoped>

</style>